export enum StockOfferUnit {
  Tonne = 'Tonne',
  Kilogram = 'Kilogram'
}
